class ArticleFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : ArticleFiltersForm.searchParamsInitial;
      if (searchParams === ArticleFiltersForm.searchParamsPrev) return;
      ArticleFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    ArticleFiltersForm.searchParamsPrev = searchParams;
    const sections = ArticleFiltersForm.getSections();
    document.getElementById('ArticleGridContainer').classList.add('loading');

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&cache=false&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      ArticleFiltersForm.filterData.some(filterDataUrl) ?
          ArticleFiltersForm.renderSectionFromCache(filterDataUrl, event) :
          ArticleFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) ArticleFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
        .then(response => response.text())
        .then((responseText) => {
          const html = responseText;
          ArticleFiltersForm.filterData = [...ArticleFiltersForm.filterData, { html, url }];
          ArticleFiltersForm.renderFilters(html, event);
          ArticleFiltersForm.renderProductGridContainer(html);
        });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = ArticleFiltersForm.filterData.find(filterDataUrl).html;
    ArticleFiltersForm.renderFilters(html, event);
    ArticleFiltersForm.renderProductGridContainer(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ArticleGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ArticleGridContainer').innerHTML;
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
        parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    ArticleFiltersForm.renderActiveFacets(parsedHTML);

    if (countsToRender) ArticleFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('article-grid').dataset.id,
      }
    ]
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData).toString();
    ArticleFiltersForm.renderPage(searchParams, event);
  }
}

ArticleFiltersForm.filterData = [];
ArticleFiltersForm.searchParamsInitial = window.location.search.slice(1);
ArticleFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('article-filters-form', ArticleFiltersForm);
ArticleFiltersForm.setListeners();

